import React from "react";
import '../../assets/css/buttons/NormalSizeLoginBtn.css';


const NormalSizeLoginBtn = ({onClickDo, children}) => {
    return (
        <button onClick={onClickDo ? onClickDo : undefined } type="button" className="flex flexCenter NormalSizeLoginBtn">
            {children ? children : "LOGIN"}
        </button>
    );
}

export default NormalSizeLoginBtn;